/* Geo auto-detection for first-time visitors.
 * Strategy:
 *  1) If user already chose a language (localStorage), do nothing.
 *  2) Else hit ipapi.co/json/ (free, no key, ~1k req/day).
 *  3) Map country / region → language.
 */

const GULF_COUNTRIES = ["AE", "SA", "QA", "OM", "KW", "BH", "YE", "JO", "LB", "EG", "IQ", "SY"];

const REGION_TO_LANG = {
    Kerala: "ml",
    "Tamil Nadu": "ta",
    Tamilnadu: "ta",
    Puducherry: "ta",
};

export const guessLangFromGeo = ({ country_code, region }) => {
    if (!country_code) return null;
    if (GULF_COUNTRIES.includes(country_code.toUpperCase())) return "ar";
    if (country_code.toUpperCase() === "IN") {
        if (region && REGION_TO_LANG[region]) return REGION_TO_LANG[region];
        return "hi";
    }
    return "en";
};

export const autoDetectLanguage = async (i18n) => {
    try {
        if (typeof window === "undefined") return;
        const stored = localStorage.getItem("southtrip_lang");
        if (stored) return; // user already picked

        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 3500);
        const r = await fetch("https://ipapi.co/json/", { signal: ctrl.signal });
        clearTimeout(timer);
        if (!r.ok) return;
        const data = await r.json();
        const guessed = guessLangFromGeo(data);
        if (guessed && i18n.language !== guessed) {
            i18n.changeLanguage(guessed);
        }
    } catch {
        /* network blocked or offline → keep default */
    }
};
